import script from "./Auth.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth.vue?vue&type=script&setup=true&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=2c633350&lang=scss"

const __exports__ = script;

export default __exports__